import { AppConfigurationClient } from "@azure/app-configuration";

const client = new AppConfigurationClient("Endpoint=https://finish-library-configuration.azconfig.io;Id=rhml;Secret=FIRzbJtAaVAkJv5WPvQ4BSf4dQKnVPvZn9EzsTeYMq4=");

export const getFilterConfig = async (env: string) => {
    const setting = await client.getConfigurationSetting({
        key: "filters",
        label: env
    });
    return setting;
}

export const getSubtypesConfig = async () => {
    const setting = await client.getConfigurationSetting({
        key: "lander_subtypes"
    });
    return setting;
}

export const getLanguageSubtypesConfig = async (locale: string) => {
    const setting = await client.getConfigurationSetting({
        key: "lander_subtypes",
        label: locale
    })
    return setting
}